import { axiosInstance } from "./axios";
import { otherTeamMemberType, removeUserType, transferOwnerShipPayloadType } from "../types";


export const getOtherTeamMemberList = async (payload:otherTeamMemberType) => {
    try {
        return await axiosInstance.post(`/team/other-members`, payload);
    } catch (error) {
        throw error;
    }
};

export const removeTeamMember = async (payload:removeUserType ) => {
    try {
      return await axiosInstance.put(`/team/remove-user`, payload);
    } catch (error) {
      throw error;
    }
};

export const transferOwnerShip = async (payload:transferOwnerShipPayloadType) => {
    try {
        return await axiosInstance.put(`/team/transfer-ownership`, payload);
      } catch (error) {
        throw error;
      }
}